import React from "react";
import { useLocation } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Reveal } from "@/components/site/SiteLayout";

const privacyContent = (
  <div className="space-y-5 text-sm leading-relaxed text-white/70">
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">1. Information We Collect</h2>
    <p>We collect information you provide directly to us, such as when you fill out a form, contact us, or use our services. This may include your name, email, phone number, and any other information you choose to provide.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">2. How We Use Information</h2>
    <p>We use your information to provide, maintain, and improve our services, respond to your inquiries, and communicate with you about updates or offers. We do not sell your personal information.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">3. Cookies & Tracking</h2>
    <p>We may use cookies and similar technologies to enhance your experience, analyze usage, and deliver relevant content. You can control cookies through your browser settings.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">4. Data Security</h2>
    <p>We implement reasonable security measures to protect your information. However, no method of transmission over the Internet is 100% secure.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">5. Your Rights</h2>
    <p>You may request access, correction, or deletion of your personal data by contacting us at support@shivedait.com.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">6. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">7. Contact</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at support@shivedait.com.</p>
  </div>
);

const termsContent = (
  <div className="space-y-5 text-sm leading-relaxed text-white/70">
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">1. Acceptance of Terms</h2>
    <p>By accessing or using our website and services, you agree to be bound by these Terms of Service and all applicable laws.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">2. Use of Services</h2>
    <p>You agree to use our services only for lawful purposes and in accordance with these terms. You may not use our services to violate any laws or regulations.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">3. Intellectual Property</h2>
    <p>All content, trademarks, and data on this site are the property of Shiveda IT Services or its licensors. You may not reproduce, distribute, or create derivative works without permission.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">4. Limitation of Liability</h2>
    <p>We are not liable for any damages arising from your use of our website or services. Our services are provided "as is" without warranties of any kind.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">5. Termination</h2>
    <p>We reserve the right to suspend or terminate your access to our services at any time, without notice, for conduct that we believe violates these terms or is harmful to other users.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">6. Changes to Terms</h2>
    <p>We may update these Terms of Service at any time. Continued use of our services after changes constitutes acceptance of the new terms.</p>
    <h2 className="text-lg font-semibold text-white mt-8 mb-2">7. Contact</h2>
    <p>If you have any questions about these Terms, please contact us at support@shivedait.com.</p>
  </div>
);

export default function Legal() {
  const { pathname } = useLocation();
  const isPrivacy = pathname.includes("privacy");
  const title = isPrivacy ? "Privacy Policy" : "Terms of Service";

  return (
    <div className="mx-auto max-w-[900px] px-5 py-16">
      <Reveal delay={0}>
        <h1 className="text-3xl font-semibold tracking-tight text-white md:text-4xl">
          {title}
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-white/70">
          {isPrivacy
            ? "Learn how we collect, use, and protect your information."
            : "Please read these terms carefully before using our website or services."}
        </p>
      </Reveal>

      <Separator className="my-10 bg-white/10" />

      <Reveal delay={120}>
        {isPrivacy ? privacyContent : termsContent}
      </Reveal>
    </div>
  );
}
